import React from 'react';
import { Outlet, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const ClientOrgLayout = () => {
    //TODO check auth permissions
    const { pathname } = useLocation();

    const pageTitle = () => {
        if (pathname.includes('org/profile')) {
            return 'Company Profile'
        } else if (pathname.includes('org/groups')) {
            return 'Groups'
        } else if (pathname.includes('org/users')) {
            return 'Users'
        } else if (pathname.includes('org/members/invite')) {
            return 'Invite User'
        } else if (pathname.includes('org/members')) {
            return 'Edit User'
        }

        return null
    }


    return (
        <>
            {!!pageTitle() && (
                <Helmet>
                    <title>{pageTitle()} | Wripple</title>
                </Helmet>
            )}
            <Outlet />

        </>
    );
};

export default ClientOrgLayout;